import { useEffect, useRef, useState } from "react";
import { consumePendingRoute } from "./pendingRouteStorage";

/**
 * The route a just-completed login should land on, or null.
 *
 * Held until the router has actually moved off the path we redirected from.
 * Releasing it any earlier re-renders the route tree while the location is
 * still the pre-redirect one, and the index route's own redirect wins the race
 * — which is how a deep link quietly turns into the default landing page.
 * Never releasing it is the opposite failure: <Navigate> stays mounted on
 * every render and the route tree behind it never appears at all.
 */
export const usePendingRouteRedirect = (currentPath: string): string | null => {
  const [redirectTo, setRedirectTo] = useState<string | null>(
    consumePendingRoute,
  );
  const redirectedFrom = useRef(currentPath);

  useEffect(() => {
    if (redirectTo && currentPath !== redirectedFrom.current) {
      setRedirectTo(null);
    }
  }, [redirectTo, currentPath]);

  return redirectTo;
};
